module.exports = __webpack_public_path__ + "img/spam1.fcc4b7d1.png";